import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { GetLocationLookupRequest, GetLookupRequest, LocationLookup, Lookup } from "../../domain";
import { Observable } from "rxjs";
import { LookupsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLookupLocationsUsecase implements UseCase<GetLocationLookupRequest, LocationLookup[]> {

  constructor(private readonly lookupsRepository: LookupsRepository) {
  }

  execute(params?: GetLocationLookupRequest): Observable<LocationLookup[]> {
    return this.lookupsRepository.getLookupLocations(params ?? {});
  }

}
